const EMPTY_CONTEXT_VALUE = "N/a";

const firstPresentValue = (...values) =>
    values.find((value) => value !== undefined && value !== null && value !== "");

export const getTestRunVersionLabel = (testRun) =>
    firstPresentValue(
        testRun?.projectVersion?.name,
        testRun?.project_version?.name,
        testRun?.projectVersionName,
        testRun?.project_version_name
    ) || EMPTY_CONTEXT_VALUE;

export const getTestRunCycleLabel = (testRun) =>
    firstPresentValue(
        testRun?.testCycle?.name,
        testRun?.test_cycle?.name,
        testRun?.cycle?.name,
        testRun?.testCycleName,
        testRun?.test_cycle_name,
        testRun?.cycleName
    ) || EMPTY_CONTEXT_VALUE;
